<!--我是固定投入组件-->
<template>
    <div>
    <!--面包屑导航-->
    <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>养殖日志</el-breadcrumb-item>
        <el-breadcrumb-item>固定投入</el-breadcrumb-item>
    </el-breadcrumb>
        <!--添加固定成本-->
    <el-button type="success" icon="el-icon-plus" @click="add" style="margin-bottom: 15px">添加</el-button>
        <el-dialog title="添加固定成本" :visible.sync="dialogFormVisible">
            <el-form :model="form" :rules="rules" ref="form">
                <el-form-item label="投入品金额(元)" prop="total" :label-width="formLabelWidth">
                    <el-input v-model="form.total" autocomplete="off" placeholder="输入投入品金额(总)"></el-input>
                </el-form-item>
                <el-form-item label="固定成本类型" prop="name" :label-width="formLabelWidth">
                    <el-select @change="getSeedlingList" v-model="form.name" placeholder="选择投入品类型">
                        <el-option  v-for="item in fixedNameList" :key="item" :label="item"
                                    :value="item"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="苗种类型" prop="name" :label-width="formLabelWidth" >
                    <el-select :disabled="isDisabled"  v-model="form.seedling" placeholder="选择苗种类型">
                        <el-option  v-for="item in seedlingList" :key="item" :label="item"
                                    :value="item"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="苗种数量" prop="name" :label-width="formLabelWidth" >
                    <el-input v-model="form.count" :disabled="isDisabled" autocomplete="off" placeholder="输入苗种数量" style="width: 200px" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
                    <el-select :disabled="isDisabled"  v-model="form.unit" placeholder="选择苗种数量单位">
                        <el-option  v-for="item in ['斤','只']" :key="item" :label="item"
                                    :value="item"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="活动时间" :label-width="formLabelWidth" prop="time">
                    <el-col :span="10">
                        <el-date-picker type="date" placeholder="选择日期" value-format="yyyy-MM-dd" v-model="form.date" style="width: 100%;"></el-date-picker>
                    </el-col>
                    <el-col class="line" :span="1">----</el-col>
                    <el-col :span="10">
                        <el-time-picker placeholder="选择时间" value-format="HH:mm:ss" v-model="form.time" style="width: 100%;"></el-time-picker>
                    </el-col>
                </el-form-item>
                <el-form-item label="其他信息" prop="description" :label-width="formLabelWidth">
                    <el-input type="textarea" v-model="form.remark" placeholder="请添加其他描述信息"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeAdd">取 消</el-button>
                <el-button type="primary" @click="submitStableIncomeAdd('form')">确 定</el-button>
            </div>
        </el-dialog>
        <!--更新固定成本-->
        <el-dialog title="更新固定成本" :visible.sync="updateDialogFormVisible">
            <el-form :model="updateForm" :rules="rules" ref="form">
                <el-form-item label="投入品总价(元)" prop="total" :label-width="formLabelWidth">
                    <el-input v-model="updateForm.total" autocomplete="off" placeholder="输入投入品金额(总)"></el-input>
                </el-form-item>
                <el-form-item label="固定成本类型" prop="name" :label-width="formLabelWidth">
                    <el-select @change="getSeedlingList" v-model="updateForm.name" placeholder="选择投入品类型">
                        <el-option  v-for="item in fixedNameList" :key="item" :label="item"
                                    :value="item"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="苗种类型" prop="name" :label-width="formLabelWidth" >
                    <el-select :disabled="isDisabled"  v-model="updateForm.seedling" placeholder="选择苗种类型">
                        <el-option  v-for="item in seedlingList" :key="item" :label="item"
                                    :value="item"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="苗种数量" prop="name" :label-width="formLabelWidth" >
                    <el-input v-model="updateForm.count" :disabled="isDisabled" autocomplete="off" placeholder="输入苗种数量" style="width: 200px" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
                    <el-select :disabled="isDisabled"  v-model="updateForm.unit" placeholder="选择苗种数量单位">
                        <el-option  v-for="item in ['斤','只']" :key="item" :label="item"
                                    :value="item"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="活动时间" :label-width="formLabelWidth" prop="time">
                    <el-col :span="10">
                        <el-date-picker type="date" placeholder="请选择日期" value-format="yyyy-MM-dd" v-model="updateForm.date" style="width: 100%;"></el-date-picker>
                    </el-col>
                    <el-col class="line" :span="1">----</el-col>
                    <el-col :span="10">
                        <el-time-picker placeholder="请选择时间" value-format="HH:mm:ss" v-model="updateForm.time" style="width: 100%;"></el-time-picker>
                    </el-col>
                </el-form-item>
                <el-form-item label="其他信息" prop="description" :label-width="formLabelWidth">
                    <el-input type="textarea" v-model="updateForm.remark" placeholder="请添加其他描述信息"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeUpdate">取 消</el-button>
                <el-button type="primary" @click="makeHandleUpdate">确 定</el-button>
            </div>
        </el-dialog>
        <!--表格区域-->
    <el-table :data="tableData" border stripe v-loading="loading" style="width: 100%">
        <el-table-column prop="name" label="名称" align="center"></el-table-column>
        <el-table-column prop="total" label="成本费用" align="center"></el-table-column>
        <el-table-column prop="count" label="数量" align="center"></el-table-column>
        <el-table-column prop="sysTime" label="填写时间" align="center"></el-table-column>
        <el-table-column width="300" align="center" fixed="right" label="操作">
            <template slot-scope="scope">
                <el-button @click="handleUpdate(scope.row)" type="primary" icon="el-icon-edit" size="medium">修改</el-button>
                <el-button @click="handleDelete(scope.row)" type="danger" icon="el-icon-delete" size="medium">删除</el-button>
            </template>
        </el-table-column>
    </el-table>
        <!--分页器-->
        <el-pagination background
                       layout="prev, pager, next"
                       :total="total"
                       :current-page="currentPage"
                       :page-size="pageSize"
                       style="text-align: center;margin-top: 10px"
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentPage" >
        </el-pagination>
    </div>
</template>

<script>
    import request from '../../../http/dialog'
    import {positiveNumber} from '../../../utils/validate'
    // const formatTime = require('format-time-date')
    export default {
        name: "stableIncome",
        inject: ['reload'],
        data(){
            return{
                /*表格绑定数据*/
                tableData:[],
                isDisabled:true,/*下拉框是否可用*/
                currentPage: 1, // 初始页
                pageSize: 8, //    每页的数据
                total: 0, //列表总个数
                /*添加弹出表单默认属性为false*/
                dialogFormVisible: false,
                /*更新弹出表单默认属性为false*/
                updateDialogFormVisible : false,
                /*弹出表单*/
                form: { // 添加操作表单
                    total:'',// price: '',/*投入品金额*/
                    name: '', /*投入品类型*/
                    seedling:'',//苗种类型
                    date: '',/*年月日*/
                    time: '',/*时分秒*/
                    remark: '', /*其他描述信息*/
                    count: '', /*苗种数量*/
                    unit: '',/*苗种单位(斤/只)*/
                },
                updateForm: { // 更新操作表单
                    id: '', // 某一项id
                    total:'',// price: '',/*投入品金额*/
                    name: '', /*投入品类型*/
                    seedling:'',//苗种类型
                    date: '',/*年月日*/
                    time: '',/*时分秒*/
                    remark: '', /*其他描述信息*/
                    count: '', /*苗种数量*/
                    unit: '',/*苗种单位(斤/只)*/
                },
                sysTime: '', // 更新需要时间
                fixedNameList:[],/*获取固定收入-->添加固定成本-->投入品类型列表*/
                seedlingList: [], /*苗种列表*/
                formLabelWidth: '120px', //表单宽度
                loading: false, //table区域加载
                rules: {
                    total: [
                        { validator: positiveNumber, trigger: 'blur' }
                    ],
                    name: [
                        { required: true, message: '请选择投入品类型', trigger: 'change' }
                    ],
                    time:[
                        { required: true, message: '请选择时间', trigger: 'change' }
                    ]

                }
            }
        },
        methods:{
            async getSeedlingList(e){ // 选中类型获取的二级目录
                if(e === '苗种'){
                    this.isDisabled = false
                    let res = await request.getSeedlingList()
                    this.seedlingList = res.data.data
                    // console.log(this.seedlingList);
                }else {
                    this.isDisabled = true
                    this.form.seedling = '',
                    this.form.count = '',
                    this.form.unit = ''
                }
            },
            /*添加固定成本按钮方法和更新操作是触发该请求*/
            async add(){
                this.dialogFormVisible = true;
               // let res = await request.fixedNameList() // 获取投入品类型列表
               // console.log(res.data.data);
                // this.fixedNameList = res.data.data
            },
            /* 获取投入品类型*/
            async getFixedNameList(){
                let res = await request.fixedNameList() // 获取投入品类型列表
                this.fixedNameList = res.data.data
            },
            /*获取表格列表*/
            async getTableList(){
                let data = {
                    pageNum:this.currentPage,
                    pageSize: this.pageSize
                }
                let table = await request.stableTableList(data)
                this.tableData = table.data.data.list
                this.total = table.data.data.total
               // console.log(this.total)
                this.loading = false
               // console.log('获取表格列表',this.tableData);
            },
            // 删除操作
           handleDelete(data) {
                //console.log(data)
                this.$confirm('此操作将永久删除该信息, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let id = data.id
                    // 删除请求
                   request.deleteStableIncome(id).then(() => { // 异步操作执行完再执行里面的内容
                       // console.log(res);
                       this.reload()// 刷新页面显示最新状态
                       this.$message.success('删除成功!')
                   })

                }).catch(() => {
                    this.$message.info('已取消删除')
                })
            },
            // 更新操作
            handleUpdate(data){
               // console.log(data);
                this.updateDialogFormVisible = true;
                this.updateForm = data
                this.sysTime = data.sysTime
               /* let sysTime = data.sysTime.split(' ') // 按照空格分隔时间
                console.log(sysTime);
                this.updateForm.date = sysTime[0]
                this.updateForm.time = sysTime[1]*/
                //console.log("更新",this.updateForm.date);
            },
            // 确认更新
            async makeHandleUpdate(){
                this.updateDialogFormVisible = false
           //     console.log(this.sysTime);
             //   console.log(this.updateForm.date,this.updateForm.time);
                let sendData = { /*添加固定收入传入数据*/
                    id: this.updateForm.id, /*id*/
                    name: this.updateForm.name, /*固定产品类型*/
                    type: 0, /*固定投入部分*/
                    // price: this.updateForm.price, /*投入品单价*/
                    username: window.sessionStorage.getItem('name'), /*用户名*/
                    remark: this.updateForm.remark, /*其他描述信息*/
                    sysTime: this.sysTime ,/*用户自定义时间*//*this.updateForm.date + ' '+this.updateForm.time */
                    unit: this.updateForm.unit, /*苗种单位(斤/只)*/
                    count: this.updateForm.count, /*苗种数量*/
                    total: this.updateForm.total//this.updateForm.price * this.updateForm.count /*固定物品总价*/
                }
                if (this.updateForm.name === '苗种')
                {
                    sendData.name = this.updateForm.seedling
                }
                if (this.updateForm.date && this.updateForm.time){
                    sendData.sysTime = this.updateForm.date + ' '+this.updateForm.time
                }
                let res = await request.updateStableIncome(sendData)
               // console.log(res);
                if (res.data.msg === 'SUCCESS') {
                    this.$message.success('更新成功')
                    this.reload() // 局部刷新这里
                }else {
                    this.$message.info('更新失败')
                }
            },
            closeUpdate () { // 取消更新
                this.updateDialogFormVisible = false
                this.$message.info('取消更新')
            },
            // pageSize改变时触发
            handleSizeChange (size) {
                this.pagesize = size
                //console.log('handleSizeChange')
            },
            // 当前页面改变时触发
            handleCurrentPage (currentPage) {
                //console.log(currentPage)
                this.currentPage = currentPage
                this.getTableList() // 切换页面获取数据
                //console.log('handleCurrentPage')
            },
            //添加固定收入请求
             submitStableIncomeAdd(form){
                this.$refs[form].validate(async(valid) => {
                    if (valid) {
                        this.dialogFormVisible = false
                        let addData = { /*添加固定收入传入数据*/
                            name: this.form.name, /*固定产品类型*/
                            type: 0, /*固定投入部分*/
                            // price: this.form.price, /*投入品单价*/
                            username: window.sessionStorage.getItem('name'), /*用户名*/
                            remark: this.form.remark, /*其他描述信息*/
                            sysTime: this.form.date + ' '+this.form.time ,/*用户自定义时间*/
                            unit: this.form.unit, /*苗种单位(斤/只)*/
                            count: this.form.count, /*苗种数量*/
                            total: this.form.total//this.form.price * this.form.count /*固定物品总价*/
                        }
                        if (this.form.name === '苗种')
                        {
                            addData.name = this.form.seedling
                        }
                        // console.log(addData);
                        let tempAddData = await request.stableTableListAdd(addData) //发送请求
                       // console.log(tempAddData);
                        if (tempAddData.data){
                             this.reload()
                        }
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });

            },
            // 取消添加
            closeAdd(){
                this.dialogFormVisible = false
                this.$message.info('取消添加')
            }
        },
        created() {
            this.getTableList()
        },
        mounted() {
            this.getFixedNameList() // 组件挂载时,获取投入品类型
        }
    }
</script>

<style scoped>
    /*使用深度选择器修改分页器颜色样式*/
    /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #1abc9c;
        color: #FFF;
    }
</style>
